module.exports = __webpack_public_path__ + "img/pays.617bc82b.png";